import { useEffect } from "react";
import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";
import { godPermission } from "src/utils/RoleBasedSecurity/permissions";

const { useState, useContext } = require("react");

const useHasPermission = (aclKey) => {
  const { userInfo } = useContext(RbsContext);
  const [result, setResult] = useState(null);
  useEffect(() => {
    const permissions = userInfo.getPermissions();
    setResult(
      Array.isArray(aclKey)
        ? aclKey.some(
            (key) =>
              permissions.includes(key) || permissions.includes(godPermission)
          )
        : permissions.includes(aclKey) || permissions.includes(godPermission)
    );
  }, [userInfo, aclKey]);

  return result;
};

export default useHasPermission;
